import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getDataFileA = (module_name, module_id, company_id) => {
    return httpClient.get(`${billing_expense.billing_expense_url}/${server.FILE_ATTACH}` + `/get-by-module/${module_name}/${module_id}/${company_id}`);
};
export const billing_expense_createFA = (data) => {
    return httpClient.post(`${billing_expense.billing_expense_url}/${server.FILE_ATTACH}` + `/create`, data);
};
export const billing_expense_updateFA = (id, data) => {
    return httpClient.put(`${billing_expense.billing_expense_url}/${server.FILE_ATTACH}` + `/update/${id}`, data);
};
export const billing_expense_deleteFA = (id) => {
    return httpClient.delete(`${billing_expense.billing_expense_url}/${server.FILE_ATTACH}` + `/delete/${id}`);
};
